import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import Shop from "../../images/shop.png";
 

const Shops = () => {
  const ShopsDoc = {
    title: "Shops Management",
    description: "This documentation serves as a guide to efficiently manage customer shops within our system. It covers how to view, edit, and maintain shop information to ensure a seamless experience for both customers and administrators.",
    sections: [
      {
        title: "Overview",
        content: "In this section, you will learn about the various functionalities available for managing customer shops. You will be able to view and edit shop details, ensuring that all information remains current and accurate."
      },
      {
        title: "Shop Functionalities",
        content: "The shop management section provides two primary functionalities: viewing shop details and editing shop information. These functions are essential for maintaining accurate records and enhancing customer experience.",
        image: Shop,
        imageAlt: "Shop Dashboard Overview",
        imageCaption: "Figure 1: Comprehensive view of the Shop Dashboard.",
        subsections: [
          {
            title: "Shop Management Actions",
            content: "This subsection outlines the key actions you can perform when managing shops, facilitating easy access to necessary shop information.",
            steps: [
              "1. Search Functionality: Utilize the search button to quickly locate specific shops by their name. This feature is particularly useful when dealing with a large number of shops, allowing you to find the desired shop without scrolling through the entire list.",
              "2. VIEW SHOP: Each shop entry displays vital information, including the shop's name, the date it was created, and its ownership details. This overview allows administrators to easily assess each shop's history and current status.",
              "3. EDIT SHOP: This functionality enables you to modify the shop's name as needed. Additionally, there is a toggle feature that allows you to specify whether the shop belongs to a brand or is operated by an influencer. This classification is important for marketing and operational strategies.",
              "4. (Optional Step) Additional Actions: Currently, this section does not include further actions, but future updates may introduce new functionalities to enhance shop management capabilities."
            ]
          }
        ]
      }
    ]
  };
  
  return <FeatureDocumentation {...ShopsDoc} />;
};

export default Shops;
